export default __webpack_public_path__ + "static/media/icons_settings.881cc99b.svg";